import Screen from './screen.js'

const $ = jQuery

/**
 *
 * @param {HTMLElement} element - The element to set up the hover dropdown for
 * @param {number} index - The index of the element in the list
 * @param {HTMLElement[]} list - The list of elements to set up the hover dropdown for
 */
export const setupHoverDropdown = (element, index, list) => {
    const bp = element.dataset['bsToggle.collapse']
    const $dropdownToggle = $(element)
    const $dropdownMenu = $dropdownToggle.siblings('.dropdown-menu')
    const hideDropdownDelay = 50 // ms

    if (!bp || (bp in Screen.breakpoints && Screen.mediaBreakpointUp(Screen.breakpoints[bp]))) {
        let hideDropdownTimeout = null

        // Show dropdown menu on hover/focus
        $dropdownToggle.on('mouseenter focus', (event) => {
            // If already shown, do nothing
            if ($dropdownToggle.hasClass('show')) {
                return
            }

            $dropdownToggle.dropdown('show')
        })

        // Hide the dropdown menu on hover/focus out both the button and the menu
        const hideDropdown = (event) => {
            // If already hidden or running, do nothing
            if (!$dropdownToggle.hasClass('show') || hideDropdownTimeout !== null) {
                return
            }

            hideDropdownTimeout = setTimeout(() => {
                $dropdownToggle.dropdown('hide')
                hideDropdownTimeout = null
            }, hideDropdownDelay)

            $dropdownToggle.one('mouseenter focus', (e) => {
                clearTimeout(hideDropdownTimeout)
                hideDropdownTimeout = null
            })

            $dropdownMenu.one('mouseenter focusin', (e) => {
                clearTimeout(hideDropdownTimeout)
                hideDropdownTimeout = null

                $dropdownMenu.one('mouseleave focusout', (e) => {
                    hideDropdown(e)
                })
            })
        }

        $dropdownToggle.on('mouseleave focusout', hideDropdown)
    } else if (bp in Screen.breakpoints && Screen.mediaBreakpointDown(Screen.breakpoints[bp])) {
        $dropdownToggle.dropdown('show')
    }
}

/**
 * Set up the dropdown item anchor for the journey template
 *
 * @param {HTMLElement} element - The element to set up the dropdown item anchor for
 * @param {number} index - The index of the element in the list
 * @param {HTMLElement[]} list - The list of elements to set up the dropdown item anchor for
 */
export const setupDropdownItemAnchor = (element, index, list) => {
    element.addEventListener('click', (event) => {
        // If not in the journey template yet, do nothing.
        if (!isPageTemplate('journey-template')) {
            return
        }

        event.preventDefault()

        // Close the offcanvas menu
        $('#navbarNavOffcanvas').offcanvas('hide')

        const targetId = element.hash.slice(1)
        const enterJourney = document.getElementById('enter-journey')
        if (enterJourney) {
            // If the button exists, it means the user is still in the cover
            enterJourney.click()
            const stageSelectorInitial = document.getElementById('stage-selector-initial')
            stageSelectorInitial.querySelector(`a[href="#${targetId}"]`).click()
        } else if ($body.hasClass('selector-visible--inline')) {
            // This means the journey has been already initialized and the inline selector is visible
            const stageSelectorInline = document.getElementById('stage-selector-inline')
            stageSelectorInline.querySelector(`a[href="#${targetId}"]`).click()
        } else if ($body.hasClass('selector-visible')) {
            // This means the journey has not been initialized yet, so the initial selector is visible
            const stageSelectorInitial = document.getElementById('stage-selector-initial')
            stageSelectorInitial.querySelector(`a[href="#${targetId}"]`).click()
        } else {
            // This means that the user is in the middle of a stage
            const targetIndicator = document.querySelector(
                `.side-timeline .stage-indicator[href="#${targetId}"]`
            )
            if (targetIndicator) {
                targetIndicator.click()
            } else {
                // No indicator found, use stage-selector instead
                const stageSelectorInline = document.getElementById('stage-selector-inline')
                gsap.to(window, {
                    duration: 1.5,
                    scrollTo: {
                        y: stageSelectorInline,
                        offsetY: -1,
                    },
                    onComplete: () => {
                        stageSelectorInline.querySelector(`a[href="#${targetId}"]`).click()
                    },
                })
            }
        }
    })
}

/**
 * Initialize Bootstrap 5 tooltips
 *
 * @param {number} index - Index of the element in the jQuery collection
 * @param {HTMLElement} element - Current element in the jQuery collection
 */
export const initializeBSTooltips = (index, element) => {
    const $tp = $(element)

    // Aditional Popper config
    const args = {}
    if ($tp.data('bs-strategy')) {
        args.popperConfig = {
            strategy: $tp.data('bs-strategy'),
        }
    }

    $tp.tooltip(args)
}
